export default __webpack_public_path__ + "static/media/leandro-modal.0ed661bd.jpg";